import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useLeague } from "context/leagueContext";
import LeagueLeaderboard from "views/userLeague/leaderboard";
import Rounds from "views/userLeague/rounds";
import { useGame } from "context/gameContext";
import { useLeagueData } from "hooks/useLeagueData";
import { useTournamentData } from "hooks/useTournamentData";
import { useModalContext } from "context/modalContext";
import { Purchases } from "@revenuecat/purchases-capacitor";
import { Capacitor } from "@capacitor/core";
import KnockoutList from "./leaderboard/knockoutList";
import { useUser } from "reactfire";
import {
  IonPage,
  IonContent,
  IonButtons,
  IonHeader,
  IonToolbar,
  IonRouterLink,
} from "@ionic/react";
import TournamentInfo from "views/userLeague/header/info";
import TournamentHeader from "./header";
import { Md2ChevronLeft } from "react-icons-ng/md2";

function Tournament() {
  const {
    state: { premium },
    dispatch,
  } = useGame();
  const { data: user } = useUser();

  const [tab, setTab] = useState(0);

  const setTabHandler = (event) => {
    setTab(event.detail.value);
  };

  const history = useHistory();

  async function checkSubscriptionStatus() {
    if (!Capacitor.isNativePlatform()) {
      dispatch({
        type: "setPremium",
        value: { isActive: false, expires: null },
      });
      return;
    }

    try {
      const customer = await Purchases.getCustomerInfo();
      const pro = customer?.customerInfo?.entitlements.all["premium"];

      if (pro && pro.isActive) {
        dispatch({
          type: "setPremium",
          value: { isActive: true, expires: pro?.expirationDate },
        });
      } else {
        dispatch({
          type: "setPremium",
          value: { isActive: false, expires: null },
        });
      }
      return;
    } catch (e) {
      console.log(e);
      return;
    }
  }

  const { openPaywallModal } = useModalContext();

  useLeagueData();
  useTournamentData();
  useEffect(() => {
    checkSubscriptionStatus();
  }, []);

  const {
    state: { leagueInfo, isLoading, tournamentInfo },
  } = useLeague();

  const containsId = leagueInfo?.users.some((id) => id === user.uid);

  if (isLoading) return <></>;

  if (!premium && tournamentInfo?.premium) {
    openPaywallModal();
    return history.push("/");
  }
  if (!containsId) {
    return history.push("/");
  }

  if (!leagueInfo?.visible)
    return (
      <IonPage>
        <IonHeader mode="ios" className="ion-no-border">
          <IonToolbar className="gradientToolbarPrimary" mode="ios">
            <IonButtons slot="start">
              <IonRouterLink
                routerLink="/tabs/tournaments"
                routerDirection="back"
                slot="start"
                className="self-middle items-center justify-center flex"
              >
                <Md2ChevronLeft className="w-8 h-8 shrink-0 text-white" />
              </IonRouterLink>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent className="mainPage">
          <div className="flex  w-full h-full items-center justify-center">
            <div className="">League has been removed</div>
          </div>
        </IonContent>
      </IonPage>
    );
  return (
    <IonPage>
      <TournamentHeader selectedTab={tab} setTabHandler={setTabHandler} />

      <IonContent className="mainPage">
        <div className="flex max-w-screen-md mx-auto">
          <div className="flex w-full flex-col">
            {tab == 0 ? (
              <div className="flex space-y-3 w-full flex-col">
                <Rounds loading={isLoading} />
              </div>
            ) : tab == 1 ? (
              leagueInfo?.gameRule == 3 || leagueInfo?.gameRule == 4 ? (
                <div className="my-2">
                  <LeagueLeaderboard
                    loading={isLoading}
                    hideElimintated={true}
                  />
                  <KnockoutList eliminated={true} loading={isLoading} />
                </div>
              ) : leagueInfo?.gameRule == 2 ? (
                <div className="my-2">
                  <KnockoutList eliminated={false} loading={isLoading} />
                  <KnockoutList eliminated={true} loading={isLoading} />
                </div>
              ) : (
                <div className="my-2">
                  <LeagueLeaderboard
                    loading={isLoading}
                    hideElimintated={false}
                  />
                </div>
              )
            ) : tab == 2 ? (
              <div className="rounded-md bg-white m-2 ">
                <TournamentInfo />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
}

export default Tournament;
